module.exports = __webpack_public_path__ + "static/BENdownarrow-66d289b2f9bfbf3fb531abd13a7a2744.png";